"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityCategory = void 0;
const rc_js_util_1 = require("rc-js-util");
const e_graphics_component_type_1 = require("../../rendering/graphics-components/e-graphics-component-type");
const initialize_graphics_component_1 = require("../../rendering/graphics-components/initialize-graphics-component");
const plot_1 = require("../../plot/plot");
const on_graphics_component_added_1 = require("../../rendering/events/on-graphics-component-added");
/**
 * @public
 * Implementation of {@link IEntityCategory}, handles initialization of graphics components.
 */
class EntityCategory {
    constructor(plot, renderer, updateGroup, updateHooks) {
        this.plot = plot;
        this.renderer = renderer;
        this.updateGroup = updateGroup;
        this.entities = new rc_js_util_1.DirtyCheckedUniqueCollection();
        this.hooks = new WeakMap();
        this.bufferPerEntity = false;
        this.updateHooks = updateHooks;
    }
    setBufferPerEntity(enabled) {
        this.bufferPerEntity = enabled;
    }
    addEntity(entity, graphicsComponent, hooks) {
        switch (graphicsComponent.type) {
            case e_graphics_component_type_1.EGraphicsComponentType.Composite:
                {
                    graphicsComponent.recurseIterate(e_graphics_component_type_1.EGraphicsComponentType.Entity, (component, containingComponent, index) => {
                        const initializedComponent = this.getInitializedGraphicsComponent(component);
                        containingComponent.subComponents.setSubComponent(initializedComponent, index);
                        this.initializeEntityBuffers(initializedComponent, entity);
                    });
                    break;
                }
            case e_graphics_component_type_1.EGraphicsComponentType.Entity:
                {
                    graphicsComponent = this.getInitializedGraphicsComponent(graphicsComponent);
                    this.initializeEntityBuffers(graphicsComponent, entity);
                    break;
                }
            default:
                rc_js_util_1._Production.assertValueIsNever(graphicsComponent);
        }
        this.plot.addEntity(entity);
        this.plot.addToGroup(entity, this.updateGroup, { graphicsComponent: graphicsComponent });
        this.entities.add(entity);
        if (hooks != null) {
            hooks.onEntityAdded(entity);
        }
    }
    removeEntity(entity) {
        const removedOne = this.entities.delete(entity);
        if (!removedOne) {
            return;
        }
        const hooks = this.hooks.get(entity);
        if (hooks != null) {
            hooks.onEntityRemoved(entity);
        }
    }
    getEntities() {
        return this.entities.getArray();
    }
    getInitializedGraphicsComponent(graphicsComponent) {
        const equiv = this.renderer.graphicsComponents.getComponent(graphicsComponent.getCacheId());
        if (equiv == null) {
            // first time we've seen this component
            (0, initialize_graphics_component_1.initializeGraphicsComponent)(this.renderer, graphicsComponent);
            on_graphics_component_added_1.OnGraphicsComponentAdded.emit(plot_1.Plot.getChartEventService(this.plot), graphicsComponent);
            return graphicsComponent;
        }
        else {
            return equiv;
        }
    }
    initializeEntityBuffers(graphicsComponent, entity) {
        if (!this.bufferPerEntity || graphicsComponent.transform.bufferLayoutProvider == null) {
            return;
        }
        const layout = graphicsComponent.transform.bufferLayoutProvider.getBufferLayout();
        if (this.renderer.sharedState.entityBuffers.setNewLayout(entity, graphicsComponent.transform.groupId, layout)) {
            this.renderer.initializeBuffers(layout.getBuffers());
        }
    }
}
exports.EntityCategory = EntityCategory;
//# sourceMappingURL=entity-category.js.map